import updateProp from '../../../_helpers/updateProp';

export default {
  updateProp,
};
